import styled from "styled-components";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";

export const Container = styled(KOGTableRow)`
	&&& {
		.MuiIconButton-root.Mui-disabled {
			color: rgba(0, 0, 0, 0.34);
		}
	}
`;

export const TableCellErrorDescription = styled.div`
	&&& {
		max-width: 700px;
		word-break: break-word !important;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		overflow: hidden;
		-webkit-box-orient: vertical;
		height: 100%;
	}
`;
